var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronSelect = function SvgChevronSelect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 16,
    height: 16,
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    shapeRendering: "geometricPrecision",
    style: {
      color: "currentcolor"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.517 12 3 7 8.517m0 6.963 5 5.517 5-5.517"
  })));
};
export default SvgChevronSelect;